import { Users, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function DashboardFansTab({ fans }) {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      {fans.length === 0 ? (
        <div className="text-center py-12">
          <Users className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Pas encore de fans</p>
          <p className="text-xs text-muted-foreground mt-1">Publie du contenu pour attirer ton public</p>
        </div>
      ) : (
        fans.map((fan) => (
          <div
            key={fan.id}
            onClick={() => navigate(`/user/${fan.id}`)}
            className="bg-card border border-border rounded-2xl p-3 flex items-center gap-3 shadow-sm cursor-pointer hover:border-[#FF6B35]/30 transition-all"
            data-testid={`fan-${fan.id}`}
          >
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#FF8FA3] flex items-center justify-center shrink-0">
              {fan.avatar_url ? (
                <img src={fan.avatar_url} alt="" className="w-full h-full rounded-full object-cover" />
              ) : (
                <span className="text-white font-heading font-bold text-sm">
                  {(fan.pseudo || "?")[0].toUpperCase()}
                </span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading font-bold text-sm text-card-foreground truncate">{fan.pseudo}</p>
              {fan.city && (
                <p className="flex items-center gap-1 text-xs text-muted-foreground">
                  <MapPin className="w-3 h-3" />{fan.city}
                </p>
              )}
            </div>
            <p className="text-[10px] text-muted-foreground shrink-0">
              {fan.followed_at ? new Date(fan.followed_at).toLocaleDateString("fr-FR") : ""}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
